// extracted by mini-css-extract-plugin
export default {"LoginPage":"LoginPage_LoginPage__o6PRW","LeftContent":"LoginPage_LeftContent__fE5yX","LoginContent":"LoginPage_LoginContent__LgT-x"};